module.exports = __webpack_public_path__ + "img/1521500443.51e85162.jpg";